import React, { useEffect, useState } from 'react';
import { Buffer } from 'buffer';
import { useStyles } from './AnnotationPreview.styles';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';

interface AnnotationPreviewProps {
  svg: string;
  onPreviewError?: () => void;
}

const AnnotationPreview: React.FC<AnnotationPreviewProps> = ({ svg, onPreviewError }) => {
  const classes = useStyles();
  const buff = Buffer.from(svg);
  const base64data = buff.toString('base64');
  const [svgLoadFailed, setSvgLoadFailed] = useState<boolean>();

  useEffect(() => {
    setSvgLoadFailed(undefined);
  }, [svg]);

  return (
    <div className={classes.icon} style={{ backgroundColor: svgLoadFailed ? '#D9D9D9' : 'white', border: 'none' }}>
      {svgLoadFailed === undefined || svgLoadFailed === false ? (
        <img
          src={`data:image/svg+xml;base64,${base64data}`}
          className={classes.img}
          onError={() => {
            setSvgLoadFailed(true);
            if (onPreviewError !== undefined && svg !== '') onPreviewError();
          }}
          onLoad={() => {
            setSvgLoadFailed(false);
          }}
          alt="adnotacja"
        />
      ) : (
        <QuestionMarkIcon sx={{ color: 'rgba(44, 45, 62, 0.7)' }} />
      )}
    </div>
  );
};

export default AnnotationPreview;
